<template>
  <div class="errors-report-block">
    <v-layout pa-2 mt-2>
      <v-flex>
        <v-card>
          <v-card-title>
            <div class="headline">&nbsp;Get errors report:</div>
          </v-card-title>
            <v-layout row wrap >
              <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
                <v-menu
                  v-model="reportDateRangeMenu"
                  full-width
                  offset-y
                  :close-on-content-click="false"
                  bottom
                  ref="reportDateRangeMenu"
                  content-class="date-range-menu"
                >
                  <v-text-field
                    slot="activator"
                    v-model="reportDateRange"
                    label="Select report date range"
                    prepend-icon="event"
                    readonly
                    clearable
                    @click:clear="clearReportDateRange(true)"
                  ></v-text-field>
                  <v-card>
                    <v-card-text>
                      <v-daterange :options="reportDateRangeOptions" no-presets @input="onReportDateRangeChange" :first-day-of-week="$store.state.user.first_day_of_week" noPresets></v-daterange>
                      <div class="text-xs-right">
                        <v-select
                          class="px-3 pt-4"
                          :items="$store.state.metadata.errorReporsTypesSelect"
                          v-model="errorType"
                        ></v-select>
                        <v-btn
                          right
                          depressed
                          color="primary"
                          @click="getErrorsReport();"
                          :loading="loading"
                          :disabled="loading"
                        >Download XLSX</v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu>
                <!-- <v-btn color="primary" class="submit"
                  @click="getErrorsReport()"
                  :loading="loading"
                  :disabled="loading"
                >Download XLSX</v-btn> -->
              </v-flex>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ErrorsReportBlock',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      errorType: null,
      reportDateRangeMenu: false,
      reportDateRange: '',
      reportDateFrom: this.$moment().add(-1, 'month').format('YYYY-MM-DD'),
      reportDateTo: this.$moment().format('YYYY-MM-DD'),
      reportDateRangeOptions: {
        format: 'YYYY-MM-DD',
        startDate: this.$moment().add(-1, 'month').format('YYYY-MM-DD'),
        endDate: this.$moment().format('YYYY-MM-DD')
      },
      loading: false
    }
  },
  methods: {
    getErrorsReport () {
      this.loading = true
      let params = {
        from_date: this.reportDateFrom,
        to_date: this.reportDateTo,
        api_error_type: this.errorType
      }
      this.$store.dispatch('GET_ERRORS_REPORT', params).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.body], { type: 'application/vnd.ms-excel' }))
        const link = document.createElement('a')
        link.href = url
        let name = `Kolyom errors report(${this.reportDateFrom} - ${this.reportDateTo}).xlsx`
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false
        this.reportDateRangeMenu = false
      }, err => {
        this.loading = false
        console.log('GET_ERRORS_REPORT error', err)
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    onReportDateRangeChange (range) {
      let to = range[1] ? range[1] : this.$moment().subtract(1, 'years').format('YYYY-MM-DD')
      let from = range[0] ? range[0] : to
      this.reportRange = range
      this.reportDateFrom = from
      this.reportDateTo = to
      this.reportDateRange = 'From: ' + this.$moment(from).format('DD-MM-YYYY') + ' - To: ' + this.$moment(to).format('DD-MM-YYYY')
    },
    clearReportDateRange (reload) {
      let to = this.$moment().format('YYYY-MM-DD')
      let from = this.$moment().subtract(this.itemChartReportPeriod, 'day').format('YYYY-MM-DD')
      this.reportRange = [from, to]
      this.reportDateFrom = from
      this.reportDateTo = to
      this.reportDateRange = 'From: ' + this.$moment(from).format('DD-MM-YYYY') + ' - To: ' + this.$moment(to).format('DD-MM-YYYY')
      if (reload) {
        this.getErrorsReport()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/ErrorsReportBlock.vue